var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeatureTileIcon02(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#E6E6FD",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38 18H26c-.6 0-1 .4-1 1v2c0 .6.4 1 1 1h12c.6 0 1-.4 1-1v-2c0-.6-.4-1-1-1z",
    fillOpacity: 0.64
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 26H26c-.6 0-1 .4-1 1v2c0 .6.4 1 1 1h12c.6 0 1-.4 1-1v-2c0-.6-.4-1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 34H26c-.6 0-1 .4-1 1v2c0 .6.4 1 1 1h12c.6 0 1-.4 1-1v-2c0-.6-.4-1-1-1z",
    fillOpacity: 0.64
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 17h-4c-.6 0-1 .4-1 1v4c0 .6.4 1 1 1h4c.6 0 1-.4 1-1v-4c0-.6-.4-1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 25h-4c-.6 0-1 .4-1 1v4c0 .6.4 1 1 1h4c.6 0 1-.4 1-1v-4c0-.6-.4-1-1-1z",
    fillOpacity: 0.64
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 33h-4c-.6 0-1 .4-1 1v4c0 .6.4 1 1 1h4c.6 0 1-.4 1-1v-4c0-.6-.4-1-1-1z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureTileIcon02);
export default __webpack_public_path__ + "static/media/feature-tile-icon-02.da24330d8156c82e159d916e940bbb3c.svg";
export { ForwardRef as ReactComponent };